import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';

import {TIMESTAMP_MULTIPLY, RADIX_DECIMAL, TIMEOUT_STORE} from 'util/constants';

const transformEntitiesFn = item => ({
    id:         item.id,
    task:       item.task ? item.task.name : '',
    lastStatus: item.last_status ? item.last_status.code : '',
    lastUpdate: (typeof item.modification_date === 'string' ? parseInt(item.modification_date, RADIX_DECIMAL) : item.modification_date) * TIMESTAMP_MULTIPLY ,
    error:      item.error
});

module.exports = {
    createFetchParams: (logsFilters, resourceId, pagination, logsSortBy) => ({
        ...logsFilters,
        resourceId,
        ...pagination,
        ordering: logsSortBy
    }),
    ...storeModuleFactory({
        name:             'operationLogs',
        endpoint:         endpoints.operationLogs.endpoint,
        instanceEndpoint: endpoints.operationLogs.instanceEndpoint,
        timeout:          TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        parseParameters:  filters => Object.keys(filters).reduce((ret, key) => ({
            ...ret,
            [key]: key === 'startDate' || key === 'endDate' ?
                filters[key] && filters[key] / TIMESTAMP_MULTIPLY :
                filters[key]
        }), {}),
        filterParamsMap: {
            resourceId: 'resource_id',
            lastStatus: 'last_status',
            startDate:  'start_date',
            endDate:    'end_date'
        },
        sortParamsMap: {
            lastStatus: 'last_status',
            lastUpdate: 'modification_date'
        },
        transformEntitiesFn
    })
};





// WEBPACK FOOTER //
// ./src/modules/store/operationLogs.js